import React, { useState, useEffect, useContext} from 'react';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink, useParams } from 'react-router-dom';
import NumberFormat from 'react-number-format';

import {
  TableCell,
  TableFooter,
  TableRow,
  makeStyles
} from "@material-ui/core";

// material
import {
    Card,
    Stack,
    Alert,
    Button,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
    AlertTitle,
    TextField,
    Autocomplete,
    FormControlLabel,
    Checkbox,
    Avatar
  } from '@mui/material';

import IconButton from "@material-ui/core/IconButton";
import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';

import {api, 
        reiniciarToken, 
        consultaVendasAvulsa, 
        excluirVendasMesa, 
        cadastrarVendas, 
        finalizaVendasAvulsa, 
        consClienteConsumidorPadrao, 
        atualizarEstoqueProduto, 
        consUsuariosEmpresa, 
        consUsuario,
        atualizarQuantidadeItens} from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth';  

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import { fFormataDinheiro, fFormataDinheiroSemCifra } from '../../utils/formatNumber';

import CadVendaForms from '../FormsTemplates/VendaComercio/CadastroVendaForms';

// utils
import { fDateFormatCalendario } from '../../utils/formatTime';
import CustomToolbar from "../../components/CustomToolbar";
import produtoPadrao from '../../images/produto_padrao.jpg';



export default function VendaAvulsa() {

  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);
  const [valorPagamento, setValorPagamento] = useState(0);
  const [formaPagamento, setFormaPagamento] = useState(1);
  const [usuarios, setListUsuario] = useState([]);
  const [usuarioParam, setUsuario] = useState(localStorage.getItem(['usuario']));
  const [showElement, setShowElement] = useState(false);
  const [entrega, setDesejaEntrega] = useState(false);
  const [dadosEntrega, setDadosEntrega] = useState([]);
  const [qtdeItens, setQtdeItens] = useState(0);

  localStorage.removeItem("mesa");

  let sumValorVenda; 
  let sumValorPago;

  const getListas = async () => {
    
    const responseProduto = await consUsuariosEmpresa();

    if(responseProduto.erro === true) {
      if (responseProduto.mensagem === 'O Token é inválido!' || responseProduto.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      responseProduto.data.forEach((valores) => {
        setListUsuario(usuarios => [...usuarios, {usuario: valores.usuario, descricao: valores.usuario}])
      });
    };
  }

  const getVendas = async () => {
    setData([]);
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consultaVendasAvulsa(usuarioParam);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      
      const valorPendente = response.data.reduce((total, item) => {
          return (total +  (item.valor_venda - item.valor_pago));
      }, 0);

      setValorPagamento(valorPendente);

      response.data.forEach((valores) => {

        setData(dados => [...dados, {id_item_venda: valores.id_item_venda, 
                                     produto: valores.produto,
                                     qtde_venda: valores.qtde_venda,
                                     valor_venda: valores.valor_venda,
                                     valor_pago: valores.valor_pago,
                                     valor_venda_formatado: fFormataDinheiro(valores.valor_venda),
                                     observacao: valores.observacao,
                                     preco_custo: valores.preco_custo,
                                     url: valores.url
                                    }]);                   
      });
    }; 
  }

  useEffect(() => {
    getVendas();
    getListas();
    
    if ((localStorage.getItem(['tipo_comercio']) === '2') && (localStorage.getItem(['menu_restrito']) === '2')) {
      setShowElement(true);  
    }

  },[])  

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  }) 
  
  
  const excluirVenda = async (id) => {
    const response = await excluirVendasMesa(id);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      getVendas();
    }; 
  } 

  const atualizarQuantidade = async (id, dados, tipoOperacao) => {
    
    const body = {qtde_venda: dados.qtde_venda,
                  quantidade: qtdeItens,
                  valor_venda: dados.preco_custo,
                  tipo_operacao: tipoOperacao}
    
    const response = await atualizarQuantidadeItens(id, body);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      setQtdeItens(0);
      getVendas();
    }; 
  } 

  const finalizarVenda = async () =>{
    
    const responseClientePadrao = await consClienteConsumidorPadrao();

    if(responseClientePadrao.erro === true) {
      if (responseClientePadrao.mensagem === 'O Token é inválido!'){
          logout();
      }else {
          setStatus({
            type: "erro",
            mensagem: responseClientePadrao.mensagem
          })
      }
    }else {
      const json = {data_venda: Date.now(),
                    id_cliente: responseClientePadrao.data[0].id_cliente,
                    id_fornecedor: 1,
                    qtde_venda: 1,
                    valor_venda: valorPagamento,
                    usuario: usuarioParam,
                    id_empresa: localStorage.getItem(['id_empresa']),
                    forma_pagamento: formaPagamento};


      const response = await cadastrarVendas(json);

      if(response.erro === true) {
        if (response.mensagem === 'O Token é inválido!'){
            logout();
        }else {
            setStatus({
              type: "erro",
              mensagem: response.mensagem
            })
        }
      }else {
          const responseVenda = await consultaVendasAvulsa(usuarioParam);
            
          if(responseVenda.erro === true) {
            if (responseVenda.mensagem === 'O Token é inválido!' || responseVenda.mensagem === 'Acesso negado!'){
              logout();
            }
          }else {
            responseVenda.data.forEach((valores) => {
              atualizarEstoqueProduto(valores.codigo_produto, {qtde_estoque: valores.qtde_estoque, qtde_venda: valores.qtde_venda});             
            });
          }; 

          const response1 = await finalizaVendasAvulsa(response.data.id_venda, valorPagamento, usuarioParam);

          if(response1.erro === true) {
            if (response1.mensagem === 'O Token é inválido!'){
                logout();
            }else {
                setStatus({
                  type: "erro",
                  mensagem: response1.mensagem
                })
            }
          }else {
            setStatus({
              type: "success",
              mensagem: response1.data.mensagem
            })
            setData([]);
            getVendas();
          };            
      };
    };
  }

  const columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem onClick={() => excluirVenda(dados[dataIndex].id_item_venda)} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Excluir" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>
                          </> 
                        );
                      }
                   }
                  }
                  ,{name: "",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
                              <MenuItem onClick={() => atualizarQuantidade(dados[dataIndex].id_item_venda, dados[dataIndex], "subtrair")} sx={{ color: 'text.secondary' }}>
                                <ListItemIcon>
                                    <Iconify icon="ic:baseline-remove-circle" width={24} height={24} />
                                </ListItemIcon>
                              </MenuItem>
                              <TextField
                                size="small"
                                style = {{width: 50}}
                                value={qtdeItens}
                                onChange={(ev) => {
                                   setQtdeItens(ev.target.value)
                                }}
                              />
                              <MenuItem onClick={() => atualizarQuantidade(dados[dataIndex].id_item_venda, dados[dataIndex], "somar")} sx={{ color: 'text.secondary' }}>
                                <ListItemIcon>
                                    <Iconify icon="material-symbols:add-circle-rounded" width={24} height={24} />
                                </ListItemIcon>
                              </MenuItem>
                            </Stack>
                          </> 
                        );
                      }
                    }
                   } 
                   ,{name: "",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <Avatar src={dados[dataIndex].url ? dados[dataIndex].url : produtoPadrao} alt="imagemProduto" sx={{ width: 100, height: 100 }} />
                          </> 
                        );
                    }
                    }
                   } 
                  ,{name:"produto", label: "Produto"}
                  ,{name:"qtde_venda", label: "Qtde Venda"}
                  ,{name:"valor_venda_formatado", label: "Valor Venda"}
                  ,{name:"observacao", label: "Observação"}
                  ];

  const useStyles = makeStyles((theme) => ({
    footerCell: {
        backgroundColor: "#cccccc",
        borderBottom: "none",
        color: "black",
        fontSize: 14,
        fontWeight: 'bold'
      }
  }));

  const classes  = useStyles();

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "multiple",
    responsive: "standard",
    selectToolbarPlacement: "none",
    print:'false',
    search: 'false',
    download: 'false',
    filter: 'false',
    viewColumns: 'false',
    onRowSelectionChange: (registroSelecionado, TodosRegistrosSelecionado) => {           
        const result = TodosRegistrosSelecionado.map(item => { return dados.at(item.index) });
        const selectedIds = result.map(item => {
            return item;
        }); 
        localStorage.setItem("dadosImpressao", JSON.stringify(selectedIds));
        localStorage.setItem("dadosEntrega", JSON.stringify(dadosEntrega));
    },
    customTableBodyFooterRender: (opts) => {
        
        sumValorVenda = dados
          .reduce((total, item) => {
            return (total +  item.valor_venda);
        }, 0);

        sumValorPago = dados 
          .reduce((total, item) => {
            return (total +  item.valor_pago);
        }, 0);

        return (
          <>
            {dados.length > 0 && (
              <TableFooter className={classes.footerCell}>
                <TableRow>
                  {opts.selectableRows !== 'none' ? <TableCell className={classes.footerCell} /> : null}
                  {opts.columns.map((col, index) => {
                    if (col.display === "true") {
                      if (col.name === "qtde_venda") {
                        return (
                          <TableCell key={index} className={classes.footerCell}>
                            TOTAL
                          </TableCell>
                        );
                      }if (col.name === "valor_venda_formatado") {
                        return (
                          <TableCell key={index} className={classes.footerCell}>
                            {fFormataDinheiro(sumValorVenda)}
                          </TableCell>
                        );
                      }if (col.name === "observacao") {
                        return (
                          <TableCell key={index} className={classes.footerCell}>
                            VALOR RESTANTE: {fFormataDinheiro(sumValorVenda-sumValorPago)}
                          </TableCell>
                        );
                      }   
                      if (col.name !== "qtde_venda" && col.name !== "valor_venda_formatado") {
                        return <TableCell key={index} className={classes.footerCell}/>
                      };
                    }
                    return <TableCell key={index} className={classes.footerCell}/>;
                    })
                  }
                </TableRow>
              </TableFooter>
            )}
          </>
        );
    }
  };   
  
  const AtribuiDadosEntrega = async (desejaEntrega) =>{
    setDesejaEntrega(desejaEntrega)
    if (desejaEntrega === true) {
      setDadosEntrega({dadosEntrega: `Endereço:\nBairro:\nTroco:\nTelefone:`})
    }else{
      setDadosEntrega({dadosEntrega: ''})
    }
  } 
                    
  return (
    <Page title="Venda">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} spacing={2}>
          <Typography variant="h4" gutterBottom>
            Cadastro de Venda
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained"  color="neutral" component={RouterLink} to="/venda/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>
        
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} spacing={2}>
        {!showElement && null}
        {showElement &&
          <Autocomplete
              getOptionLabel={(resultado) => resultado.descricao}
              options={usuarios}
              fullWidth
              onChange={(e, value) => { 
                setUsuario(value?.usuario)
              }}
              renderInput={(params) => (<TextField {...params} 
                                          label="Lista de Atendentes" 
                                          fullWidth
                                          />
                                        )}
              isOptionEqualToValue={(option, value) => option.usuario === value.usuario}
          />}
          {!showElement && null}
          {showElement &&
          <ThemeProvider theme={Theme}>
            <Button variant="contained"  color="neutral" onClick={() => { getVendas() }} >
              Consultar
            </Button>
          </ThemeProvider>
          }
        </Stack>
        
        <Stack mb={5}> </Stack>

        <Stack mb={2} spacing={10}>
          <CadVendaForms/>
        </Stack>

        
        <Stack spacing={3}>
          {status.type === 'erro' ? <Alert severity="error"><AlertTitle>Erro</AlertTitle>{status.mensagem}</Alert> : ""}
          {status.type === 'success' ? <Alert severity="success"><AlertTitle>Sucesso</AlertTitle>{status.mensagem}</Alert> : ""}
        </Stack > 

        <Stack mb={2} spacing={10}>
          <MUIDataTable
              title={<CustomToolbar/>}
              data={Object.values(dados)}
              columns={columns}  
              options={options} 
          />
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <TextField 
              select
              fullWidth
              label="Forma de Pagamento"
              value={formaPagamento}
              onChange={(ev) => {
                setFormaPagamento(ev.target.value)
              }}
            >
              <MenuItem value ="1">Dinheiro</MenuItem>
              <MenuItem value ="2">PIX</MenuItem> 
              <MenuItem value ="3">Cartão de Crédito</MenuItem>
              <MenuItem value ="4">Cartão de Débito</MenuItem>
          </TextField>
          <NumberFormat
            fullWidth
            label="Valor Pagamento"
            decimalScale={2}
            value={valorPagamento}
            onChange={(ev) => {
              setValorPagamento(ev.target.value)
            }}
            decimalSeparator={','}
            customInput={TextField}
            
          />
        </Stack>
        <Stack mb={2}> </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <FormControlLabel
              control={<Checkbox
                checked={entrega}
                name="deseja_entrega"
                onChange={(newValue) =>
                  AtribuiDadosEntrega(newValue.target.checked)
                }
              />
              }
              label={<Typography>Deseja Entrega?</Typography>}
          />
          <TextField
            fullWidth
            multiline='true'
            rows={5}
            rowsMax={6}
            value={dadosEntrega.dadosEntrega}
            onChange={(ev) => {
              setDadosEntrega({dadosEntrega: ev.target.value})
            }}
          />
        </Stack>
        <Stack mb={2}> </Stack>
        <Stack>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" onClick={finalizarVenda}>
                Finalizar Venda
            </Button>
          </ThemeProvider>
        </Stack>
      </Container>  
    </Page>  
  );
}
